<template>
  <section class="article-edit">
    <article-header
      :disabled="disabled"
      :type="2"
      :status="editStatus"
      @preView="preView"
      @submit="submit"
      :id="id"
    />
    <p class="link-help-wrap">
      <router-link type="div" :to="'/treaty/3317'" class="link-help" target="_blank">
        <img src="/static/questions_icon@2x.png" />
        {{$t('global.帮助手册')}}
      </router-link>
    </p>
    <div class="editcomponents">
      <textarea
        rows="1"
        class="editinput"
        type="text"
        maxlength="100"
        :placeholder="
          `${$t('global.请输入标题')}（${$t('global.最多')}100${$t('global.个字')}）`"
        v-model="form.title"
      ></textarea>
      <span v-if="errorMessage">{{errorMessage}}</span>
      <tinymc-editor
        class="editor"
        :content="form.content"
        @changeEdit="updateContent"
        :height="height"
      />
    </div>
  </section>
</template>

<script>
import ArticleHeader from "@/components/v2/article/articleHeader";
import tinymcEditor from "@/components/editor/Editor";
export default {
  metaInfo() {
    return {
      title: this.$t("global.写文章") + " | MANA"
    };
  },
  components: {
    ArticleHeader,
    tinymcEditor
  },
  data() {
    return {
      editStatus: 0,
      form: {
        title: "",
        content: "",
        typeId: 0
      },
      topicId: null,
      errorMessage: "",
      id: null,
      timer: null,
      oldTitle: "",
      oldContent: ""
    };
  },
  watch: {
    "form.title"(val) {
      this.errorMessage = "";
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.autoEdit();
      }, 1000);
    },
    "form.content"(val) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.autoEdit();
      }, 1000);
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (localStorage.getItem("auth_token")) {
        this.topicId = this.$route.query.topicId;
        this.id = this.$route.query.id || null;
        if (this.id) {
          this.getDetail();
        }
      } else {
        this.$router.push(`/login?redirecturl=${window.location}`);
      }
    },
    getDetail() {
      const url = `/api/topic/answerInfo/preview`;
      const params = {
        topicQuestionId: this.id
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          const questionDomain = res.data.questionDomain;
          this.topicId = questionDomain.topicId;
          this.form = {
            title: questionDomain.title,
            content: questionDomain.content
          };
          this.oldTitle = questionDomain.title;
          this.oldContent = questionDomain.content;
        }
      });
    },
    updateContent(content) {
      this.form.content = content;
    },
    preView() {
      if (!this.form.title.trim() || !this.form.content || !this.id) {
        this.$message.error(this.$t("global.请输入标题和正文"));
      } else {
        this.autoEdit();
        this.$router.push(`/article/preview/${this.id}`);
      }
    },
    autoEdit() {
      if (this.form.content && this.form.title.length <= 100) {
        if (
          this.form.title !== this.oldTitle ||
          this.form.content !== this.oldContent
        ) {
          this.saveDraft();
        }
      } else {
        return false;
      }
    },
    saveDraft() {
      this.editStatus = 1;
      let url = `/api/u/topicquestion/createArticle`;
      let params = {
        ...this.form,
        status: 0,
        id: this.id
      };
      if (this.topicId) {
        url = `/api/u/topicquestion/create`;
        params = {
          ...params,
          topicId: this.topicId
        };
      }
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.id = res.data.id;
          this.editStatus = 2;
          this.oldTitle = this.form.title;
          this.oldContent = this.form.content;
        }
      });
    },
    submit() {
      if (!this.form.title.trim() || !this.form.content || !this.id) {
        this.$message.error(this.$t("global.请输入标题和正文"));
      } else {
        clearTimeout(this.timer);
        let url = `/api/u/topicquestion/createArticle`;
        let params = {
          ...this.form,
          id: this.id,
          status: 1
        };
        if (this.topicId) {
          url = `/api/u/topicquestion/create`;
          params = {
            ...params,
            topicId: this.topicId
          };
        }
        this.$http.post(url, params).then(res => {
          if (res.code === "OK") {
            this.$router.push("/my/article");
          }
        });
      }
    }
  },
  computed: {
    disabled() {
      return !this.form.title || !this.form.content || !this.id;
    },
    height() {
      return document.querySelector("html").offsetHeight - 210;
    }
  }
};
</script>

<style lang="stylus" scoped>
input, button, select, textarea {
  outline: none;
}

.article-edit {
  background: #fff;

  .link-help-wrap {
    width: 730px;
    margin: 0 auto;
    padding-top: 118px;
    text-align: right;

    .link-help {
      font-size: 16px;
      line-height: 18px;

      &:visited {
        color: #2026cc;
      }

      img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
        vertical-align: bottom;
      }
    }
  }

  .editcomponents {
    width: 730px;
    margin: 0 auto;
    padding-top: 20px;
    min-height: calc(100vh - 156px);

    .editinput {
      width: 100%;
      min-height: 40px;
      margin-bottom: 20px;
      padding: 0;
      border: none;
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;

      &::placeholder {
        color: #999;
        font-size: 28px;
      }
    }

    &>span {
      margin-top: -20px;
      color: #FE5630;
      font-size: 14px;
      text-align: right;
      display: block;
      padding-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/article/ArticleEdit.vue